__turbopack_context__.v({
  "textAreaInput": "textAreaInput-module-scss-module__ekBkta__textAreaInput",
});
